import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import {
    GetMethodData,
    DecryptAESdata, GetPostMethodData
} from "../../../provider/ServiceProvider";
import './../LatestDividend/LatestDividend.css'
import * as XLSX from 'xlsx';
import execl from '../../../images/excel.png'
// import Pagination from 'rc-pagination';
import { Pagination } from "antd";
import { Vortex } from 'react-loader-spinner'
import animation from '../../../images/jm-animation.gif';



function LatestDividend() {
    const [data, setData] = useState("");
    const [dataDrop, setDataDropdown] = useState("");
    const [values, setValues] = useState("equity");
    const [Valuesdrop, setValuesdrop] = useState("")
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [size, setSize] = useState(perPage);
    const [current, setCurrent] = useState(1);
    const { BaseURL, BaseURLShare } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    const [dataDropFund, setDataDropdownFund] = useState("");
    const [DropdownFundCode, setDataDropdownFundCode] = useState('');
    const [DropdownFundType, setDataDropdownFundType] = useState('');
    const [selectedOptionFundCode, setSelectedOption] = useState('');
    const [showAdditionalDropdowns, setShowAdditionalDropdowns] = useState(false);
    const [optiondesc, setSelectedOptionOptionDesc] = useState('');
    const [showAdditionalDropdowns2, setShowAdditionalDropdowns2] = useState(false);
    const [selectedOptionFundtype, setSelectedOptionFundCode] = useState('');
    const [showAdditionalDropdowns1, setShowAdditionalDropdowns1] = useState(false);
    const [activeTab, setActiveTab] = useState("Equity");
    let PageSize = size;

    const handleChangeFundName = (event) => {
        setData('');
        const selectedValue = event.target.value;
        setSelectedOption(selectedValue);
        if (selectedValue !== '') {
            setShowAdditionalDropdowns(true);
        } else {
            setShowAdditionalDropdowns(false);
        }
    };


    const handleChangeFundCode = (event) => {
        setData('');
        const selectedValue = event.target.value;
        setSelectedOptionFundCode(selectedValue);
        if (selectedValue !== '') {
            setShowAdditionalDropdowns1(true);
        } else {
            setShowAdditionalDropdowns1(false);
        }
    };

    const handleChangeOptiinDesc = (event) => {
        setData('');
        const selectedValue = event.target.value;
        setSelectedOptionOptionDesc(selectedValue);
        if (selectedValue !== '') {
            setShowAdditionalDropdowns2(true);
            setData('')
        } else {
            setShowAdditionalDropdowns2(false);
        }
    };

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetLatestDividend", {
            "type": values,
            "IVSchemeCode": '',
            "period": ""
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                // console.log(DecryptAESdata(data.data))
                setloadingshow(false);
            }
            else {
                setData('');
                setloadingshow(false);
            }
        });
    }, [BaseURL, values]);

    const buttonGo = (event) => {
        // event.preventDefault();
        GetPostMethodData(BaseURL + "GetLatestDividend", {
            "type": values,
            "IVSchemeCode": optiondesc
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                // console.log(DecryptAESdata(data.data))
                // setloadingshow(false);
            }
        }, [BaseURL, values, optiondesc]);
    }

    const columns = [
        { label: 'Scheme Code', value: 'schemecode' },
        { label: 'Scheme Name', value: 'schemename' },
        { label: 'NAV Date', value: 'navdate' },
        { label: 'NAV', value: 'nav' },
        { label: 'Corporate IDCW', value: 'corpdiv' },
        { label: 'Individual IDCW', value: 'noncorpdiv' },
    ];
    useEffect(() => {
        setSelectedOptionFundCode(''); 
    }, [selectedOptionFundCode]);

    useEffect(() => {

        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
            "IVPage": "IDWC",
            "type": values,
            "IVFundCode": '',
            "IVPlanType": ''

        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setDataDropdownFund(DecryptAESdata(data.data))
                setloadingshow(false);
            }
        });
        GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
            "IVPage": "IDWC",
            "type": values,
            "IVFundCode": selectedOptionFundCode,
            "IVPlanType": ''

        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setDataDropdownFundCode(DecryptAESdata(data.data))
                setloadingshow(false);
            }
        });
        GetPostMethodData(BaseURL + "GetNavDetailsDrop", {
            "IVPage": "IDWC",
            "type": values,
            "IVFundCode": selectedOptionFundCode,
            "IVPlanType": selectedOptionFundtype

        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setDataDropdownFundType(DecryptAESdata(data.data))
                setloadingshow(false);
            }
            // if(selectedOptionFundtype != ""){
            //     document.getElementsByClassName('btn-go-nav').style.display = "block";
            // }
        });
    }, [BaseURL, values, selectedOptionFundCode, selectedOptionFundtype]);



    const handleChange = (e) => {
         e.preventDefault();
        const valueLi = e.currentTarget.getAttribute("data-value")
        setValues(valueLi)
        setActiveTab(valueLi); 
        setValuesdrop("")
        setShowAdditionalDropdowns(false);
        setSelectedOptionOptionDesc('');
        setSelectedOption('')
        // setData('')
    }

    function exportToExcel(data, columns) {
        const dataNew = data.map(item => {
            const dataItem = {};
            columns.forEach(column => {
                dataItem[column.label] = item[column.value];
            });
            return dataItem;
        });
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dataNew);
        const columnWidths = [
            { wch: 12 },
            { wch: 50 },
            { wch: 15 },
            { wch: 12 },
            { wch: 15 },
            { wch: 15 },
        ];
        worksheet['!cols'] = columnWidths;
        const cellNumberFormat = '#,##0.00';
        const cell = XLSX.utils.encode_cell({ r: 0, c: 0 });
        worksheet[cell].z = cellNumberFormat;
        XLSX.utils.book_append_sheet(workbook, worksheet, 'LatestIDCW');
        XLSX.writeFile(workbook, 'LatestIDCW.xlsx');
    }

    const currentTableData = useMemo(() => {
        if (data != null) {
            const firstPageIndex = (current - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null) {
                if (data.length > 0) {
                    // return data.slice(firstPageIndex, lastPageIndex);
                    return data.slice((current - 1) * PageSize, current * PageSize);
                }
            }
        }
    }, [current, data, PageSize]);

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize);
    }

    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button><i className="fa fa-angle-double-left"></i></button>;
        }
        if (type === 'next') {
            return <button><i className="fa fa-angle-double-right"></i></button>;
        }
        return originalElement;
    }
    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className="navs-and-dividends-section">
                            <div className="container-fluid p-0">
                                <div className="tab-content sub-content" id="pills-tabContent">
                                    <div className="tab-pane nav-tab fade show active" id="pills-nav" role="tabpanel"
                                       >
                                        <div className="container">

                                            <div className="tab-content sub-content" id="nav-tabContent">
                                                <div className="tab-pane fade show active" id="pills-latest-nav" role="tabpanel"
                                                  >
                                                    {/* <h2>Latest NAV</h2> */}
                                                    <div className="tile inner-tab" id="">
                                                        <ul className="nav nav-tabs nav-justified" role="tablist" >

                                                            {/* <li className="nav-item" data-value="" onClick={(e) => handleChange(e)}>
                                                                <a className="nav-link active" id="equity-schemes-tab" data-toggle="tab"
                                                                    href="#equity-schemes" role="tab" aria-controls="equity-schemes"
                                                                    aria-selected="true">All</a>
                                                            </li> */}
                                                            <li className="nav-item" data-value="Equity" onClick={(e) => handleChange(e)}>
                                                                <a className={`nav-link ${activeTab === "Equity" ? "active" : ""}`} 
                                                                     id="equity-schemes-tab" data-toggle="tab"
                                                                    href="#equity-schemes" role="tab" aria-controls="equity-schemes"
                                                                    aria-selected="true">Equity</a>
                                                            </li>
                                                            <li className="nav-item" data-value="fixedincome" onClick={(e) => handleChange(e)}>
                                                                <a className={`nav-link ${activeTab === "fixedincome" ? "active" : ""}`}
                                                                    id="arbitrage-schemes-tab" data-toggle="tab"
                                                                    href="#arbitrage-schemes" role="tab"
                                                                    aria-controls="arbitrage-schemes" aria-selected="false">Fixed Income</a>
                                                            </li>
                                                            <li className="nav-item" data-value="Hybrid" onClick={(e) => handleChange(e)}>
                                                                <a className={`nav-link ${activeTab === "Hybrid" ? "active" : ""}`}
                                                                    id="debt-schemes-tab" data-toggle="tab"
                                                                    href="#debt-schemes" role="tab" aria-controls="debt-schemes"
                                                                    aria-selected="false">Hybrid</a>
                                                            </li>
                                                        </ul>


                                                        <div className="tab-content inner-content">
                                                            <div className="tab-pane latest-nav-tab fade show active" id="equity-schemes"
                                                                role="tabpanel" aria-labelledby="equity-schemes-tab">

                                                                <div className="header-wrapper">
                                                                    {/* <form action=""> */}
                                                                    <div className="header-container">
                                                                        <div className="form-container" >

                                                                            <label htmlFor="first-dropdown">Select Fund</label>

                                                                            <div className="select-container">
                                                                                <select id="first-dropdown" className="fund-selector" onChange={handleChangeFundName} value={selectedOptionFundCode}>
                                                                                    <option value="">Please Select Fund</option>
                                                                                    {dataDropFund && dataDropFund.map(({ schemecode, schemename }) => (
                                                                                        <option value={schemecode}>{schemename}</option>
                                                                                    )
                                                                                    )}
                                                                                </select>
                                                                                <i className="fa fa-caret-down" aria-hidden="true"></i>
                                                                            </div>

                                                                            {showAdditionalDropdowns && (
                                                                                <div>
                                                                                    <label htmlFor="second-dropdown">Select Plan</label>
                                                                                    <div className="select-container">
                                                                                        <select id="second-dropdown" className="fund-selector" onChange={handleChangeFundCode} value={selectedOptionFundtype}>
                                                                                            <option value="">Please Select Plan</option>
                                                                                            {DropdownFundCode && DropdownFundCode.map(({ PlanType }) => (
                                                                                                <option value={PlanType}>{PlanType}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                                                                                    </div>
                                                                                    <label htmlFor="third-dropdown">Select Option</label>
                                                                                    <div className="select-container">
                                                                                        {selectedOptionFundtype === "" ? <select id="third-dropdown" className="fund-selector" onChange={handleChangeOptiinDesc} value={optiondesc}>
                                                                                            <option value="">Please Select Option</option>
                                                                                        </select> : <select id="third-dropdown" className="fund-selector" onChange={handleChangeOptiinDesc} value={optiondesc}>
                                                                                            <option value="">Please Select Option</option>
                                                                                            {DropdownFundType && DropdownFundType.map(({ SchemeCode, OptionDesc }) => (
                                                                                                <option value={SchemeCode}>{OptionDesc}</option>
                                                                                            ))}
                                                                                        </select>}

                                                                                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                                                                                    </div>
                                                                                    {/* {optiondesc != "" ? 
                                                                                        <div className="btn-go-nav">
                                                                                            <button onClick={buttonGo}>View Nav</button>
                                                                                        </div> 
                                                                                        :
                                                                                         <div></div>} */}
                                                                                    {/* <div className="btn-go-nav">
                                                                                            <button onClick={buttonGo}>View Nav</button>
                                                                                        </div> */}
                                                                                </div>
                                                                            )}
                                                                            {optiondesc != "" ?
                                                                                <div className="btn-go-nav">
                                                                                    <button onClick={buttonGo}>VIEW IDCW</button>
                                                                                </div>
                                                                                :
                                                                                <div></div>}
                                                                            {/* <select name="fund" id="fund" className="fund-selector" onChange={(event) => setValuesdrop(event.target.value)}>
                                                                                    <option value=''>Select Scheme</option>
                                                                                    {dataDrop && dataDrop.map(
                                                                                        ({ schemename, Nav, navdate, schemecode }) => (
                                                                                            <option value={schemecode} >{schemename}</option>
                                                                                        )
                                                                                    )}
                                                                                    {loadingshow ? <div className="textcentervertex"> */}
                                                                            {/* <Vortex
                                                                                            visible={true}
                                                                                            height="80"
                                                                                            width="80"
                                                                                            ariaLabel="vortex-loading"
                                                                                            wrapperStyle={{}}
                                                                                            wrapperClass="vortex-wrapper"
                                                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                                                        /> */}
                                                                            {/* <img src={animation} alt="Loading" />
                                                                                        <div className="model_popup">Please Wait...</div>
                                                                                    </div> : ""
                                                                                    }
                                                                                </select> */}

                                                                        </div>
                                                                        {/* <button className="button header-btn" onClick={() => exportToExcel(data)}></button> */}
                                                                        <div className="export-excel">
                                                                            <img src={execl} onClick={() => exportToExcel(data, columns)} alt="export-excel"></img>
                                                                        </div>
                                                                    </div>
                                                                    {/* </form> */}
                                                                </div>
                                                                <div className="funds-container">
                                                                    <div className="table-responsive">

                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th rowspan="2">
                                                                                        Scheme Name
                                                                                    </th>
                                                                                    <th rowspan="2" className="">
                                                                                        Record Date
                                                                                    </th>
                                                                                    <th colspan="2" className="text-center">
                                                                                        IDCW Per Unit (Rs.)
                                                                                    </th>
                                                                                    <th rowspan="2" className="text-right">
                                                                                        Ex-IDCW NAV on Record Date
                                                                                    </th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th className="fund-type text-center">
                                                                                        Individual
                                                                                    </th>
                                                                                    <th className="fund-type text-center">
                                                                                        Corporate
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            {/* {currentTableData && currentTableData.length > 0 ? ( */}
                                                                            <tbody>
                                                                            {(currentTableData === null) ? <div className="errorMsg"><h3>No Data Found</h3></div> : ''}
                                                                                {currentTableData && currentTableData.map(
                                                                                    (
                                                                                        { corpdiv, isinno, nav, navdate, noncorpdiv, plansoption, schemename
                                                                                        },
                                                                                        index
                                                                                    ) => (
                                                                                        <tr>
                                                                                            <td>{schemename}</td>
                                                                                            <td>{navdate}</td>
                                                                                            <td className="text-end">{Number(noncorpdiv).toLocaleString("en-IN", {
                                                                                                minimumFractionDigits: 8,
                                                                                                maximumFractionDigits: 8,
                                                                                            })}</td>
                                                                                            <td className="text-end">{Number(corpdiv).toLocaleString("en-IN", {
                                                                                                minimumFractionDigits: 8,
                                                                                                maximumFractionDigits: 8,
                                                                                            })}</td>
                                                                                            <td className="text-end">{Number(nav).toLocaleString("en-IN", {
                                                                                                minimumFractionDigits: 4,
                                                                                                maximumFractionDigits: 4,
                                                                                            })}</td>
                                                                                        </tr>
                                                                                    )
                                                                                )}
                                                                                {loadingshow ? <div className="textcentervertex">
                                                                                   
                                                                                    <img src={animation} alt="Loading" />
                                                                                    <div className="model_popup">Please Wait...</div>
                                                                                </div> : ""
                                                                                }
                                                                            </tbody>
                                                                            {/* ) : (
                                                                                <h5 className="errormsgComNew">No Data Found !!!</h5>
                                                                              )} */}
                                                                        </table>

                                                                    </div>
                                                                </div>
                                                                {currentTableData && currentTableData.length != null ? (
                                                                    <Pagination
                                                                    align="end"
                                                                        className="pagination-data"
                                                                        showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                                                                        onChange={PaginationChange}
                                                                        total={data.length != null ? data.length : 0}
                                                                        current={current}
                                                                        pageSize={size}
                                                                        showTitle = {false}
                                                                        showSizeChanger={false}
                                                                        itemRender={PrevNextArrow}
                                                                    />
                                                                ) : (
                                                                    <p className="errorPeer">No Data Found</p>
                                                                )}



                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>

        </>
    )
}

export default LatestDividend